<template>
  <div class="pecipeList">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="代理商" label-width="60px">
        <DicInput @fieldId="fieldId($event,'operatorId')" :initName="searchForm.operatorId" :dicType="6"></DicInput>
      </el-form-item>
      <el-form-item label="药房">
        <DicInput @fieldId="fieldId($event,'pharmacyId')" :initName="searchForm.pharmacyId"  :dicType="8"></DicInput>
      </el-form-item>
      <el-form-item label="设备类型">
        <DicInput @fieldId="fieldId($event,'deviceId')" :initName="searchForm.deviceId" :dicType="1"></DicInput>
      </el-form-item>
      <el-form-item label="时间范围">
        <el-date-picker
            @input="search"
            v-model="searchForm.loginTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          style="width: 100%"
      >
        <el-table-column
            prop="itemName"
            label="统计项目名称">
        </el-table-column>
        <el-table-column
            prop="itemNameExt"
            label="统计项目附加信息">
        </el-table-column>
        <el-table-column
            prop="count"
            label="数量">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
<!--    <div style="margin-top: 20px">-->
<!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
<!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
<!--    </div>-->
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import {pickerOptions} from '@/service/common'
import DicInput from "@/components/DicInput";
export default {
  name: "pecipeList",
  data() {
    return {
      pickerOptions:pickerOptions,
      tableData: [],
      srcList: [],
      doctor_count: '',
      searchForm: {
        start:'',
        end:'',
        loginTime:[],
        deviceType:'',
        operatorId:'',
        pharmacyId:'',
        deviceId:'',
        exceptionType:'',
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      dialogVisible: false,
      doctorDetails: ''
    }
  },
  components: {
    Pagination,
    DicInput
  },
  methods: {
    // -------------------查询条件/清空-------------------
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.searchForm = {
        start:'',
        end:'',
        loginTime:[],
        deviceType:'',
        operatorId:'',
        pharmacyId:'',
        deviceId:'',
        exceptionType:'',
      }
      this.init()
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        start:this.searchForm.loginTime[0],
        end:this.searchForm.loginTime[1],
        // page: this.currPage,
        // pageSize: this.pageSize,
      }
      delete data.loginTime
      this.axios
           .get("/Statistics/PFExceptionDealStatistic/GetExceptionStatisticByExceptionType",{params: data})
          .then((res) => {
            this.tableData = res
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.pecipeList {
  text-align: start;
  min-height: 800px;

  & > div:nth-child(1) {
    margin-bottom: 20px;

    .el-button {
      box-shadow: 0 4px 8px #FFE0BA;
    }
  }
  .decBox{
    padding-right: 20px;
    i{
      font-style: normal;
    }
  }
  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .doctorDetails {
    .titleName {
      font-weight: bold;
      padding-right: 10px;
    }

    .detailsLine {
      padding-bottom: 20px;
    }

    .tagList {
      margin-right: 10px;
    }
  }
}
</style>